import type { MutationOptions } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';
import { apiClient } from '@/_config/lib/axios/api-client';
import { queryClient } from '@/_config/lib/react-query/query-client';
import {
  handleResponseSuccess,
  handleResponseThrowError,
} from '@/_utils/services';
import type { PutMissionParams } from '../types';
import { GET_MISSION_BY_ID } from './get-mission-by-id';
import { GET_MISSION_RANKING } from './get-mission-ranking';
import { GET_MISSIONS } from './get-missions';

const putMission = async ({ missionId, ...payload }: PutMissionParams) =>
  apiClient
    .put(`/missions/${missionId}`, {
      startDate: payload.startDate.toISOString(),
      endDate: payload.endDate.toISOString(),
      name: payload.name,
      budget: payload.budget,
      rewardLevels: payload.rewardLevels,
      title: payload.title,
      description: payload.description,
    })
    .then(response =>
      handleResponseSuccess(response, 'Missão atualizada com sucesso!')(),
    )
    .catch(handleResponseThrowError('Não foi possível atualizar a missão.'));

export const usePutMission = ({
  onSuccess,
  ...options
}: MutationOptions<unknown, unknown, PutMissionParams> = {}) => {
  return useMutation({
    mutationFn: putMission,
    onSuccess: (...args) => {
      queryClient.invalidateQueries([GET_MISSIONS], { exact: false });
      queryClient.invalidateQueries([GET_MISSION_BY_ID], { exact: false });
      queryClient.invalidateQueries([GET_MISSION_RANKING], { exact: false });
      onSuccess?.(...args);
    },
    ...options,
  });
};
